import React, { useState, useEffect } from "react";
import { Button, Col, Row, Typography, Icon, Stack, Space } from 'witmeg-ui-system'
import { useHistory } from 'react-router'
import "./OrderPage.scss"
import { useSelector, useDispatch } from 'react-redux';
import { getCurrencyFormat, LOCAL_STORAGE_ITEMS_NAMES } from "../../utilities/helper/helper";
import { deleteCartItem, getFloorDetails, updateCartItemQuantity, updateOrderTypeDetails } from "../../utilities/api/restaurantsService";
import { setOrderCartItems, setOrderData, setOrderEmpty } from "../../../../../../../redux/resturantWidgetSlice";
import DeletePopup from "../../components/Cart/DeletePopup";
import { Select } from "antd";

const OrderSummaryPage = () => {
    const restaurantDataState = useSelector((state) => state.resturantData);
    const [orderType, setOrderType] = useState(restaurantDataState.orderDetails.FulfillmentType)
    const [floorData, setFloorData] = useState([])
    const [tables, setTables] = useState([])
    const [selectedFloor, setSelectedFloor] = useState(null)
    const [selectedTable, setSelectedTable] = useState(null)
    const [selectedURLFloor, setSelectedURLFloor] = useState(null)
    const [selectedURLTable, setSelectedURLTable] = useState(null)
    const { Option } = Select;
    const [isDeleteItem, setIsDeleteItem] = useState("")
    const customerDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS)) : {}
    const defaultDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))
    let history = useHistory();
    const [dineInError, setDineInError] = useState(false)

    const dispatch = useDispatch()

    const onBackToMenu = () => {
        history.push("/order/checkout")
    }
    const orderTypes = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).orderTypes

    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;
    const IMAGE_PLACEHOLDER = 'data:image/png;base64,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';
    const currencyFormat = getCurrencyFormat(restaurantDataState.currency);
    useEffect(() => {
        if (defaultDetails && defaultDetails.defaultOrderType === "table" && orderType === "DINE_IN") {
            getFloorDetails().then((response) => {
                if (response) {
                    setFloorData(response)
                    let value = response.map((floor) =>
                        floor.Tables.map((table) => {
                            if (table.LocalID === defaultDetails.tableLocalId) {
                                let floorDataValue = {
                                    Id: floor.ID,
                                    Name: floor.ItemName.Translations.en,
                                    LocalReference: { Id: floor.LocalID }
                                }
                                let data = {
                                    TableID: table.ID,
                                    TableName: table.TableName,
                                    LocalReference: { Id: table.LocalID },
                                    Floor: floorDataValue
                                }
                                setSelectedFloor(floorDataValue)
                                setSelectedTable(data)
                                setSelectedURLFloor(floorDataValue)
                                setSelectedURLTable(data)
                                return data;
                            }
                            return null;
                        })
                    )
                        .flat()
                        .filter(Boolean)[0];
                    let updatedData = { ...restaurantDataState.orderDetails, FulfillmentType: orderType, DineIn: value }
                    dispatch(setOrderData(updatedData))
                }
            })
        }
    }, [])
    useEffect(() => {
        let updatedData = { ...restaurantDataState.orderDetails, FulfillmentType: orderType }
        if (orderType === "DINE_IN") {
            getFloorDetails().then((response) => {
                if (response) {
                    setFloorData(response)
                    let selectedFloorValue = response[0]
                    let floorValue = {
                        Id: selectedFloorValue.ID,
                        Name: selectedFloorValue.ItemName.Translations.en,
                        LocalReference: { Id: selectedFloorValue.LocalID }
                    }
                    setSelectedFloor(floorValue)
                    let Tables = response?.find((floor) => floor.ID === floorValue.Id)?.Tables
                    let selected = Tables[0]
                    let tableValue = {
                        TableID: selected.ID,
                        TableName: selected.TableName,
                        LocalReference: { Id: selected.LocalID },
                        Floor: selectedFloor
                    }
                    setSelectedTable(tableValue)
                    setTables(Tables)
                }
            })

        } else {
            updatedData = { ...updatedData, DineIn: {} }
        }
        dispatch(setOrderData(updatedData))

    }, [orderType])
    useEffect(() => {
        if (selectedURLTable === null) {
            setSelectedURLFloor(null)
            setSelectedURLTable(null)
            setSelectedTable(null)
            setTables([])
            setTimeout(() => {
                if (floorData) {
                    let Tables = floorData?.find((floor) => floor.ID === selectedFloor.Id)?.Tables
                    let selected = Tables[0]
                    let tableValue = {
                        TableID: selected.ID,
                        TableName: selected.TableName,
                        LocalReference: { Id: selected.LocalID },
                        Floor: selectedFloor
                    }
                    setSelectedTable(tableValue)
                    setTables(Tables)
                }
            }, 0);
        }
    }, [selectedFloor, orderType])
    const updateTotalPrice = (price, quantity) => {
        const createPriceObj = (priceValue, quantity) => ({
            Amount: priceValue * quantity,
            FormattedText: currencyFormat((priceValue * quantity) / 100),
            FormattedAmount: Number(((priceValue * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.Delivery.Amount || 0, quantity),
            TakeAway: createPriceObj(price?.TakeAway.Amount || 0, quantity),
            DineIn: createPriceObj(price?.DineIn.Amount || 0, quantity),
            CurrencyCode: "GBP"
        });
        const totalPrice = getPriceData(price, quantity);
        return totalPrice
    }
    const increaseQty = (item) => {
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount + 1,
            "CountryISOCode": "GB"
        }
        const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
            itemValue.ID === item.ID
                ? {
                    ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount + 1 },
                    PriceInfo: {
                        ...itemValue.PriceInfo,
                        BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount + 1),
                        TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount + 1)
                    }
                }
                : itemValue
        );
        dispatch(setOrderCartItems(updatedArray))
        updateCartItemQuantity(data).then((response) => {
            dispatch(setOrderData(response))
        })
    }
    const decreaseQty = (item) => {
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount - 1,
            "CountryISOCode": "GB"
        }
        if (data.NewQuantity > 0) {
            const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
                itemValue.ID === item.ID
                    ? {
                        ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount - 1 },
                        PriceInfo: {
                            ...itemValue.PriceInfo,
                            BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount - 1),
                            TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount - 1),

                        }
                    }
                    : itemValue
            );
            dispatch(setOrderCartItems(updatedArray))
            updateCartItemQuantity(data).then((response) => {
                dispatch(setOrderData(response))
            })

        } else {
            let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== item.ID)
            dispatch(setOrderCartItems(cartArray))
            deleteCartItem(item.ID).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== isDeleteItem)
                        dispatch(setOrderCartItems(cartArray))
                        setIsDeleteItem("")
                    } else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                        history.push("/")
                    }
                }
            })
        }
    }
    const deleteItem = () => {
        if (isDeleteItem !== "") {
            deleteCartItem(isDeleteItem).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== isDeleteItem)
                        dispatch(setOrderCartItems(cartArray))
                        setIsDeleteItem("")
                    } else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                        history.push("/")
                    }
                }
            })
        }
    }


    const getPrice = (
        basePrice
    ) => {
        let priceValue;
        switch (orderType) {
            case "DELIVERY_BY_REWARDCONSUMER":
                priceValue = basePrice.Delivery.FormattedText;
                break;
            case "DINE_IN":
                priceValue = basePrice.DineIn.FormattedText;
                break;
            case "TAKE_AWAY":
                priceValue = basePrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = basePrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }
    const getTotalPrice = (
        baseTotalPrice
    ) => {
        let priceValue;
        switch (orderType) {
            case "DELIVERY_BY_REWARDCONSUMER":
                priceValue = baseTotalPrice.Delivery.Amount;
                break;
            case "DINE_IN":
                priceValue = baseTotalPrice.DineIn.Amount;
                break;
            case "TAKE_AWAY":
                priceValue = baseTotalPrice.TakeAway.Amount;
                break;
            default:
                priceValue = baseTotalPrice.Delivery.Amount;
                break;
        }
        return priceValue
    }
    const getCartTotal = () => {
        let total = currencyFormat(restaurantDataState.orderCartData.Items.reduce((accumulator, currentItem) => {
            return accumulator + getTotalPrice(currentItem.PriceInfo.BaseTotalPrice)
        }, 0) / 100)
        return total

    }
    const renderModifierGroups = (selectedGroup) => {
        return (
            <div>
                <span>{selectedGroup.Title} <span className="qty-box">{selectedGroup.Quantity.Amount}</span></span>
                {selectedGroup.SelectedItems.map((selectedItem, index) => (
                    <span key={index}>
                        <span className="addon-title">
                            {selectedItem.Title} ({getPrice(selectedItem.PriceInfo.BaseTotalPrice)})
                        </span>
                        {selectedItem.SelectedModifierGroups && selectedItem.SelectedModifierGroups.length > 0 && (
                            <span>
                                {selectedItem.SelectedModifierGroups.map((nestedGroup, nestedIndex) => (
                                    <span key={nestedIndex}> {renderModifierGroups(nestedGroup)}</span>
                                ))}
                            </span>
                        )}
                        {index < selectedGroup.SelectedItems.length - 1 && <span>, </span>}
                    </span>
                ))}
            </div>
        );
    };
    const updateOrderType = (type) => {
        let body = {
            "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID),
            "DeliveryType": type,
            "CountryCode": "GB"
        }
        updateOrderTypeDetails(body).then((res) => {
            dispatch(setOrderData(res))
        })
    }
    return (
        <div className='OrderPage order-confirmation-page'>
            <Button className="eco-order-confirm-back-but eco-mb-24" category="icon-text" icon="chevron-left" text={"Back"} iconSize={16} variant="subtle" onClick={onBackToMenu} />
            <div className="Order-confirmation">
                <Typography type="title" level={1} className="eco-mb-32 eco-order-confirm-title" color="gray_darkest">Order Summary</Typography>
                <div className="eco-mb-16">
                    <div className="order-form eco-mb-36">
                        <div className="form-header">Delivery Detail</div>
                        <div className="order-form-container">
                            <Row className="eco-mb-24" gutter={[16, 16]}>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row className="eco-mb-24">
                                        <Col lg={5} className="details-label" >Customer Name :</Col> <Col className="details-content">{customerDetails?.Name?.FirstName} {customerDetails?.Name?.LastName}</Col> </Row>
                                    <Row>
                                        <Col lg={5} className="details-label">Customer Address :</Col>
                                        <Col className="details-content">
                                            {customerDetails?.BillingAddress?.AddressLine1} {customerDetails?.BillingAddress?.StateProvinceRegion}, {customerDetails?.BillingAddress?.Country} {customerDetails?.BillingAddress?.PostZipCode} </Col></Row>

                                </Col>
                                <Col lg={12} sm={24} xs={24}>
                                    <Row><Col lg={5} className="details-label">Delivery Address :</Col> <Col className="details-content">{customerDetails?.DeliveryAddress?.AddressLine1} {customerDetails?.DeliveryAddress?.StateProvinceRegion}, {customerDetails?.DeliveryAddress?.Country} {customerDetails?.DeliveryAddress?.PostZipCode}
                                        <div className='eco-product-add-ctl'
                                        >
                                            <a href={'/order/checkout'}>
                                                <Icon name="pencil" size={16} />

                                            </a>
                                        </div>
                                    </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="order-form">
                        <div className="form-header">
                            <Row gutter={[16, 16]}>
                                <Col lg={12} sm={24} xs={24}>Order Summary</Col>
                                <Col lg={12} sm={24} xs={24} className="toggle-container">
                                    <div className="toggle-tab">
                                        {orderTypes && orderTypes.includes("delivery") && <div className={`toggle-item ${orderType === "DELIVERY_BY_REWARDCONSUMER" ? 'selected' : ""}`}
                                            onClick={() => {
                                                updateOrderType("DELIVERY_BY_REWARDCONSUMER")
                                                let value = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))
                                                let updated = { ...value, defaultOrderType: "delivery" }
                                                localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA, JSON.stringify(updated))
                                                setSelectedTable(null)
                                                setOrderType("DELIVERY_BY_REWARDCONSUMER")
                                            }}
                                        >Delivery</div>}
                                        {orderTypes && orderTypes.includes("collection") && <div className={`toggle-item ${orderType === "TAKE_AWAY" ? 'selected' : ""}`}
                                            onClick={() => {
                                                updateOrderType("TAKE_AWAY")
                                                let value = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))
                                                let updated = { ...value, defaultOrderType: "collection" }
                                                localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA, JSON.stringify(updated))
                                                setSelectedTable(null)
                                                setOrderType("TAKE_AWAY")
                                            }}
                                        >Collection</div>}
                                        {orderTypes && orderTypes.includes("table") && <div className={`toggle-item ${orderType === "DINE_IN" ? 'selected' : ""}`}
                                            onClick={() => {
                                                updateOrderType("DINE_IN")
                                                let value = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))
                                                let updated = { ...value, defaultOrderType: "table" }
                                                localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA, JSON.stringify(updated))
                                                setOrderType("DINE_IN")
                                            }}
                                        >Dine In</div>}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="order-form-container">
                            {orderType === "DINE_IN" && <div className="floor-dropdown">
                                <Row gutter={[16, 16]}>
                                    <Col lg={6} className="floor-drop-container">
                                        <div className="label">Floor</div>
                                        <Select className="select-floor" onChange={(id) => {
                                            let selected = floorData.find((floor) => floor.ID === id)
                                            let floorValue = {
                                                Id: selected.ID,
                                                Name: selected.ItemName.Translations.en,
                                                LocalReference: { Id: selected.LocalID }
                                            }
                                            setSelectedFloor(floorValue)
                                            setDineInError(false)
                                        }}
                                            value={selectedURLFloor ? selectedURLFloor.Name : selectedFloor ? selectedFloor.Name : ""}
                                        >
                                            {floorData && floorData?.map((floor, key) => {
                                                return (
                                                    <Option value={floor.ID} key={key}>
                                                        {floor.ItemName.Translations.en}
                                                    </Option>
                                                )
                                            }
                                            )}
                                        </Select>
                                    </Col>
                                    <Col lg={6} className="floor-drop-container">
                                        {tables.length > 0 && <>
                                            <div className="label">Table</div>
                                            <Select className="select-floor"
                                                onChange={(id) => {
                                                    let selected = tables.find((table) => table.ID === id)
                                                    let tableValue = {
                                                        TableID: selected.ID,
                                                        TableName: selected.TableName,
                                                        LocalReference: { Id: selected.LocalID },
                                                        Floor: selectedFloor
                                                    }
                                                    setSelectedTable(tableValue)
                                                    setDineInError(false)

                                                }}
                                                value={selectedURLTable ? selectedURLTable.TableName : selectedTable ? selectedTable.TableName : ""}
                                            >
                                                <Option value=''>
                                                </Option>
                                                {tables && tables?.map((table, key) => {
                                                    return (
                                                        <Option value={table.ID} key={key}>
                                                            {table.TableName}
                                                        </Option>
                                                    )
                                                }
                                                )}
                                            </Select>
                                        </>
                                        }
                                    </Col>
                                </Row>
                            </div>}

                            <div className="eco-mb-16 desktop-view">
                                {isCartDataAvailable ?

                                    <table className="eco-order-summary-table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>PRODUCT</th>
                                                <th>PRICE</th>
                                                <th>QUANTITY</th>
                                                <th>TOTAL PRICE</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isCartDataAvailable && restaurantDataState.orderCartData.Items.map((item, index) => {
                                                const _hasAddons = item.SelectedModifierGroups.length > 0;

                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <div onClick={() => {
                                                                setIsDeleteItem(item.ID)
                                                            }}>
                                                                <Icon name="cancel" type="filled" className="close-icon" />
                                                            </div>
                                                        </td>
                                                        <td valign={_hasAddons ? 'top' : 'center'}>
                                                            <Stack horizontalAlign="h_start" verticalAlign={_hasAddons ? 'v_start' : 'v_center'}>
                                                                <div
                                                                    style={{ backgroundImage: `url(${item.PictureURL !== "" ? item.PictureURL : IMAGE_PLACEHOLDER})`, objectFit: item.PictureURL === "" ? "fill" : "" }}
                                                                    className="eco-order-summary-image" />
                                                                <Stack direction="column" verticalAlign="v_start" className="eco-ml-32">
                                                                    <Space size="middle" className={_hasAddons && "eco-mb-24"}>
                                                                        <Typography type="title" className="item-name">
                                                                            {item.Title}
                                                                        </Typography>
                                                                    </Space>
                                                                    {_hasAddons && item.SelectedModifierGroups.map((selectedGroup, index) => (
                                                                        <span key={index}> {renderModifierGroups(selectedGroup)} </span>
                                                                    ))}

                                                                </Stack>
                                                            </Stack>
                                                        </td>
                                                        <td valign={_hasAddons ? 'top' : 'center'}>
                                                            <Stack direction="column" verticalAlign="v_start">
                                                                <Typography type="title" level={5} pattern="bold" className={_hasAddons && "eco-mb-24"}>
                                                                    {getPrice(item.PriceInfo.UnitPrice
                                                                    )}
                                                                </Typography>

                                                            </Stack>
                                                        </td>
                                                        <td valign={_hasAddons ? 'top' : 'center'}>
                                                            <div style={{ border: '1px solid #EAE8ED', borderRadius: '6px', width: 'fit-content', display: 'flex', alignItems: 'center' }}>
                                                                <div style={{ padding: '5px', borderRight: '1px solid #EAE8ED', cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        decreaseQty(item)
                                                                    }}
                                                                >
                                                                    <Icon name="minus" size={16} />
                                                                </div>
                                                                <div style={{ borderRight: '1px solid #EAE8ED' }}>
                                                                    <input className='input-order-amount' value={item.Quantity.Amount} readOnly />
                                                                </div>
                                                                <div style={{ padding: '5px', cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        increaseQty(item)
                                                                    }}
                                                                >
                                                                    <Icon name="plus" size={16} readOnly />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td valign={_hasAddons ? 'top' : 'center'} style={{ textAlign: 'center' }}>
                                                            <Typography type="title" level={5} pattern="bold">{getPrice(item.PriceInfo.TotalPrice
                                                            )}</Typography>
                                                            <Space size="middle" className="eco-mt-24">
                                                                <div className='eco-product-add-ctl'
                                                                    onClick={() => {
                                                                        localStorage.setItem("QUANTITY", JSON.stringify([item]))
                                                                    }}
                                                                >
                                                                    <a href={'/item/' + item.CartItemID + "/" + item.ID}>

                                                                        <Icon name="pencil" size={16} />

                                                                    </a>
                                                                </div></Space>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            <tr >
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td colSpan={2} >
                                                    <Stack direction="column" verticalAlign="v_end" className="eco-mb-36">
                                                        <Stack horizontalAlign="space_between" className="eco-mb-36">
                                                            <Typography type="text">Sub total</Typography>
                                                            <Typography type="text" pattern="bold" style={{ marginRight: "10px" }}>
                                                                {restaurantDataState.orderDetails.Payment.
                                                                    PaymentDetail.OrderTotal.Net.Formatted}
                                                            </Typography>
                                                        </Stack>
                                                        {/* {
                                                            orderType === 'DELIVERY_BY_REWARDCONSUMER' && (
                                                                <Stack horizontalAlign="space_between" className="eco-mb-36">
                                                                    <Typography type="text">Delivery Charge:</Typography>
                                                                    <Typography type="text" pattern="bold" style={{ marginRight: "10px" }}>
                                                                        £ 0.00
                                                                    </Typography>
                                                                </Stack>
                                                            )
                                                        } */}
                                                        {restaurantDataState?.orderDetails?.Payment.
                                                            PaymentDetail?.Fee?.Details?.map((fee, key) => {
                                                                return (
                                                                    <Stack horizontalAlign="space_between" className="eco-mb-36" key={key}>
                                                                        <Typography type="text">{fee.Description}</Typography>
                                                                        <Typography type="text" style={{ marginRight: "10px" }}>
                                                                            {fee.Amount.DisplayAmount}
                                                                        </Typography>
                                                                    </Stack>
                                                                )
                                                            })}

                                                        <Stack horizontalAlign="space_between" className="eco-mb-36">
                                                            <Typography type="text" pattern="bold">Total:</Typography>
                                                            <Typography type="text" pattern="bold">
                                                                <span style={{ backgroundColor: '#F4F4F4', padding: '10px', borderRadius: '8px', fontSize: "20px" }}>
                                                                    {restaurantDataState.orderDetails.Payment.
                                                                        PaymentDetail.OrderTotal.Gross.Formatted}
                                                                </span>
                                                            </Typography>
                                                        </Stack>
                                                        <Button
                                                            category={"icon-text"}
                                                            text="Proceed to Payment"
                                                            variant="primary"
                                                            color="white"
                                                            onClick={() => {
                                                                let customerData = [{ ...restaurantDataState.orderDetails.Customers[0], ...customerDetails }]
                                                                let updatedData = { ...restaurantDataState.orderDetails, Customers: customerData, FulfillmentType: orderType, DineIn: selectedTable ? selectedTable : {} }
                                                                if (orderType === "DINE_IN" && Object.keys(updatedData.DineIn).length === 0) {
                                                                    setDineInError(true)
                                                                } else {
                                                                    setDineInError(false)
                                                                    dispatch(setOrderData(updatedData))
                                                                    history.push("/order/payment/selection")
                                                                }

                                                            }}
                                                            className="proceed-payment-button"
                                                        />
                                                        {dineInError && <Typography className="error-text">*Select a table and floor to continue</Typography>}

                                                    </Stack>

                                                </td>

                                            </tr>

                                        </tbody>
                                    </table> :
                                    <div className="empty-cart">
                                        <div className="empty">
                                            <div className="empty-text  eco-mb-24"> No cart items</div>
                                            <Button
                                                category={"icon-text"}
                                                text="Continue Shopping"
                                                variant="primary"
                                                color="white"
                                                onClick={() => {
                                                    history.push("/")
                                                }}
                                                className="proceed-payment-button"
                                            />
                                        </div>
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <DeletePopup
                visibility={isDeleteItem !== ""}
                onPopupClose={() => {
                    setIsDeleteItem("")
                }}
                onDeleteConfirm={deleteItem} />
        </div >
    )

}
export default OrderSummaryPage